import { buildPermissionsFromApiCodes } from "./buildPermissionsFromApi";
import { APP_ROLE } from "./roleKinds";

const ROLE_KIND_BY_NORMALIZED_NAME = {
  admin: APP_ROLE.ADMIN,
  administrator: APP_ROLE.ADMIN,
  client: APP_ROLE.CLIENT,
  developer: APP_ROLE.DEVELOPER,
  dev: APP_ROLE.DEVELOPER,
  manager: APP_ROLE.MANAGER,
};

/**
 * Permissions come only from GET /users/me `role.permissions` (API codes).
 * Each mapped code sets that app key to `true`; every other known key is `false`.
 * If `permissions` is missing or not an array, all known keys are `false`.
 *
 * Role **name** is not used to grant access — only the `permissions` array.
 */
export function resolvePermissions(role) {
  return buildPermissionsFromApiCodes(role?.permissions);
}

/** Normalizes `me.role.name` from GET /users/me (always an object; `name` may be missing). */
export function normalizeRoleName(role) {
  if (role == null) return "";
  return String(role.name ?? "")
    .trim()
    .toLowerCase();
}

export function resolveRoleKind(role) {
  return ROLE_KIND_BY_NORMALIZED_NAME[normalizeRoleName(role)] ?? null;
}
